/*global window, $, google, document*/

const SFTranslator = {
  applyTranslation: (language, fileLocationPath = null) => {
    if (fileLocationPath == null) {
      fileLocationPath = fileLocationPath + 'translation.' + language + '.json'
    }
    $.getJSON(fileLocationPath, function (translationData) {
      if (!translationData) {
        return;
      }
      for (const item in translationData) {
        const $labelKey = $('[data-SF_translation_key="' + item + '"]')
        $labelKey.html(translationData[item])
        if ($labelKey.attr('for')) {
          $('#' + $labelKey.attr('for')).attr('placeholder', translationData[item])
        }
      }
    });
  }
}

const Utilities = {
  formatCurrency: (currency) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(currency)
  },
  copyElementValueToClipboard: function (element_id) {
    const copyText = document.getElementById(element_id);
    copyText.select();
    copyText.setSelectionRange(0, 99999); /* For mobile devices*/
    document.execCommand('copy'); /* Copy the text inside the text field */
  },
}

const AffiliateDashboard = {
  Affiliate: {
    profile: {},
    share: {},
    commissions: {},
    bonuses: {},
  },
  onLoad: () => {
    const $affiliate_dashboard_main = $('#affiliate-dashboard-main')
    if (!$affiliate_dashboard_main.length) {
      return
    }
    const affiliateId = $affiliate_dashboard_main.attr('affiliate-id').trim()
    if (!affiliateId) {
      return
    }
    AffiliateDashboard.onLoadDatePicker()

    AffiliateDashboard.getDashboardData()

    AffiliateDashboard.generateQRCode()
    AffiliateDashboard.onQrCodeActionClick()
    AffiliateDashboard.onAffiliatePaypalMetafieldUpdate()
    AffiliateDashboard.onAffiliateDOBMetafieldUpdate()
    AffiliateDashboard.onAffiliateGenderMetafieldUpdate()
    AffiliateDashboard.onAffiliateDOBMetafieldSaveListener()
    AffiliateDashboard.onAffiliateGenderMetafieldSaveListener()

    const $copyReferralUrlBtn = $('#btn-copy-username-referral-url')
    if ($copyReferralUrlBtn.length) {
      AffiliateDashboard.onClickCopyBtn($copyReferralUrlBtn)
    }

  },
  onLoadDatePicker: () => {
    const $affiliateDashboardDatePicker = $('#affiliate-dashboard-date-picker')
    if (!$affiliateDashboardDatePicker.length) {
      return
    }

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth()
    const currentYear = currentDate.getFullYear()

    if (!$.fn.datetimepicker) {
      let monthFormat = currentMonth
      monthFormat++;
      if (monthFormat < 10) {
        monthFormat = '0' + monthFormat
      }
      $('#affiliate-dashboard-date-picker #datepicker').val(currentYear + '-' + (monthFormat))
      setTimeout(function () { AffiliateDashboard.onLoadDatePicker(); }, 100);
      return;
    }

    $affiliateDashboardDatePicker.datetimepicker({
      format: 'YYYY-MM',
      defaultDate: new Date(currentYear, currentMonth),
    }).on('dp.change', function () {
      console.log('affiliateDashboardDatePicker change')
      AffiliateDashboard.getDashboardData()
    })
  },
  onAffiliatePaypalMetafieldUpdate: () => {
    $('#SF-affiliate-paypal-metafield-update').on('click', async (e) => {
      const $this = $(e.currentTarget)
      // eslint-disable-next-line no-undef
      const prompt_text = $this.data('prompt');
      const type = $this.data('type');
      const value = $this.data('value');

      const newValue = prompt(prompt_text, value)
      await AffiliateDashboard.updateAffiliateMetafield(type, newValue)
    })
  },
  onAffiliateDOBMetafieldUpdate: () => {
    $('#SF-affiliate-dob-metafield-update').on('click', async () => {
      $('#SF-affiliate-dob-metafield-container').removeClass('visible')
      $('#SF-affiliate-dob-metafield-update-container').addClass('visible')
    })
  },
  onAffiliateGenderMetafieldUpdate: () => {
    $('#SF-affiliate-gender-metafield-update').on('click', async () => {
      $('#SF-affiliate-gender-metafield-container').removeClass('visible')
      $('#SF-affiliate-gender-metafield-update-container').addClass('visible')
    })
  },
  onAffiliateDOBMetafieldSaveListener: () => {
    const $action = $('#SF-affiliate-dob-metafield-save-update');
    $action.off('click', AffiliateDashboard.onAffiliateDOBMetafieldSave)
    $action.on('click', AffiliateDashboard.onAffiliateDOBMetafieldSave)
  },
  onAffiliateDOBMetafieldSave: (e) => {
    const $action = $(e.target)
    $action.attr('disabled', true)
    AffiliateDashboard.updateAffiliateMetafield('dateOfBirth', $('#SF-affiliate-dob-metafield-value').val()).then(res => {
      $action.removeAttr('disabled', true)
      if (res.success == true) {
        location.reload()
        return
      }
      alert('Unable to update please try again')
    })
  },
  onAffiliateGenderMetafieldSaveListener: () => {
    const $action = $('#SF-affiliate-gender-metafield-save-update');
    $action.off('click', AffiliateDashboard.onAffiliateGenderMetafieldSave)
    $action.on('click', AffiliateDashboard.onAffiliateGenderMetafieldSave)
  },
  onAffiliateGenderMetafieldSave: (e) => {
    const $action = $(e.target)
    $action.attr('disabled', true)
    AffiliateDashboard.updateAffiliateMetafield('gender', $('#SF-affiliate-gender-metafield-value').val()).then(res => {
      $action.removeAttr('disabled', true)
      if (res.success == true) {
        location.reload()
        return
      }
      alert('Unable to update please try again')
    })
  },
  updateAffiliateMetafield: (type, value) => {
    return $.ajax({
      type: 'POST',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/metafield`,
      data: {
        type,
        value
      },
    })
  },
  onQrCodeActionClick: () => {
    $('#view_my_affiliate_qr_code').on('click', (e) => {
      const $currentElement = $(e.target);
      if ($currentElement.data('open') == 'true') {
        $currentElement.data('open', 'false')
        $currentElement.html('View')
        $('#affiliate_qr_code').hide()
      } else {
        $('#affiliate_qr_code').show()
        $currentElement.data('open', 'true')
        $currentElement.html('Hide')
      }
    })
  },
  generateQRCode: () => {
    const $SFfiliate_username_referral_url = document.getElementById('SFfiliate_username_referral_url')
    if (!$SFfiliate_username_referral_url) {
      return
    }
    // eslint-disable-next-line no-undef
    QRCode.toCanvas(document.getElementById('affiliate_qr_code'), $SFfiliate_username_referral_url.value, function (error) {
      if (error) console.error(error)
      console.log('success!');
    })
  },
  getDashboardData: async () => {
    try {
      const selectedDate = $('#datepicker').val()
      const affiliateId = $('#affiliate-dashboard-main').attr('affiliate-id').trim()
      const tempResponse = await AffiliateDashboard.getDashboard(affiliateId, selectedDate)
      const affiliateDashboardResponse = JSON.parse(tempResponse)

      AffiliateDashboard.Affiliate.profile = affiliateDashboardResponse.affiliate
      AffiliateDashboard.Affiliate.share = affiliateDashboardResponse.share
      AffiliateDashboard.Affiliate.commissions = affiliateDashboardResponse.commissions
      AffiliateDashboard.Affiliate.bonuses = affiliateDashboardResponse.bonuses
      AffiliateDashboard.setBonuses(AffiliateDashboard.Affiliate.bonuses)
      AffiliateDashboard.setShare(AffiliateDashboard.Affiliate.share)
      AffiliateDashboard.setCommissions(AffiliateDashboard.Affiliate.commissions, AffiliateDashboard.Affiliate.share)
      const orders = affiliateDashboardResponse.orders
      $('.affiliate-order-snippet').show()
      AffiliateDashboard.setOrders(orders)
      if (!orders || orders.length == 0) {
        $('.affiliate-order-snippet').hide()
      }

      const downline = affiliateDashboardResponse.downline
      $('.affiliate-downline-snippet').show()
      AffiliateDashboard.setDownLine(downline)
      if (!downline || !downline.length) {
        $('.affiliate-downline-snippet').hide()
      }
      if (window.SFShopifyApp.translate_to) {
        SFTranslator.applyTranslation(window.SFShopifyApp.translate_to, window.SFShopifyApp.translate_file_location)
      }
    } catch (e) {
      console.log(e)
    }
    $('#affiliate-dashboard').removeClass('loading')
  },
  getAffiliate: (affiliateId) => {
    return $.ajax({
      type: 'GET',
      url: `https://z2wqq.wiremockapi.cloud/json`,
      //url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate`,
      data: {
        id: affiliateId,
      },
    })
  },
  getDashboard: (affiliateId, period) => {
    return $.ajax({
      type: 'GET',
      url: `https://z2wqq.wiremockapi.cloud/getDashboard`,
      //url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/dashboard`,
      data: {
        id: affiliateId,
        period,
      },
    })
  },
  getAffiliateMonthlyShare: (affiliateId, period, group_id) => {
    return $.ajax({
      type: 'GET',
      url: `https://z2wqq.wiremockapi.cloud/json`,
      //url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/monthly/share`,
      data: {
        id: affiliateId,
        period,
        share: group_id,
      },
    })
  },
  setShare: (share_data) => {
    if (!share_data) {
      $('.dashboard-share-title').hide()
      return
    }
    $('.dashboard-share-title').show()
    const share_affiliates = share_data.affiliates
    const share_levels = []
    let totalShares = 0
    // bonuses calculations
    for (var i = 0; i < share_affiliates.length; i++) {
      const affiliate = share_affiliates[i]
      const level = affiliate.level
      if (!share_levels[level]) {
        share_levels[level] = 0
      }
      share_levels[level] += affiliate.shareEarned
      totalShares += affiliate.shareEarned * share_data.sharePrice
      console.log(affiliate.shareEarned, share_data.sharePrice)
    }
    AffiliateDashboard.Affiliate.share.totalShares = totalShares
    $('.dashboard-share-wrapper').empty()
    $('.dashboard-share-wrapper').append(`<p>Share Price: <span>${Utilities.formatCurrency(share_data.sharePrice)}</span></p>`)
    $.each(share_levels, function (index) {
      $('.dashboard-share-wrapper').append(`<p>Group ${index} Shares: <span> ${share_levels[index]}</span></p>`)
    })
    $('.dashboard-share-wrapper').append(`<span class="total-line"><p>Total Share Volume: <span>${Utilities.formatCurrency(totalShares)}</span></p></span>`)
  },
  setCommissions: (commissions, share) => {
    $('#affiliate-performance-dashboard-chart').hide()

    if (!commissions || !commissions.length) {
      $('.no-data-chart').show()
      $('.dashboard-retail-wrapper').empty()
      $('.dashboard-share-wrapper').empty()

      $('.dashboard-retail-wrapper').append(`<p><span><span data-SF_translation_key="personalVolumePV">Personal Volume (PV)</span>:</span><span>${Utilities.formatCurrency(0)}</span></p>`)
      $('.dashboard-retail-wrapper').append(`<p><span><span data-SF_translation_key="customerVolumeCV">Customer Volume (CV)</span>:</span><span>${Utilities.formatCurrency(0)}</span></p>`)
      console.log(window.SFShopifyApp.move_volume_outside)

      if (!window.SFShopifyApp.move_volume_outside) {
        $('.dashboard-retail-wrapper').append(`<p><span><span data-SF_translation_key="newVolume">New Volume (NV):</span></span><span>${Utilities.formatCurrency(0)}</span></p>`)
      }

      $('.dashboard-retail-wrapper').append(`
      <span class="total-line">
          <p>
            <span>
              <span data-SF_translation_key="totalPersonalSalesTPS">Total Personal Sales (TPS)</span>:</span>
            <span>${Utilities.formatCurrency(0)}</span>
          </p>
        </span>`)
      if (window.SFShopifyApp.move_volume_outside) {
        $('.dashboard-retail-wrapper').append(`<p class="h2"><span><span data-SF_translation_key="newVolume">New Volume (NV)</span>:</span><span>${Utilities.formatCurrency(0)}</span></p>`)
      }

      $('.dashboard-earnings-wrapper').html(`
        <p><span><span data-SF_translation_key="level">Level</span> 0 CV: 0%</span><span>${Utilities.formatCurrency(0)}</span></p>
        <span class="earnings-total-line">
          <p class="line"></p>
          <p><span><span data-SF_translation_key="totalEarnings">Total Earnings</span>: </span><span><span>${Utilities.formatCurrency(0)}</span></p>
          <p><span><span data-SF_translation_key="paidToDate">Paid to Date</span>: </span><span><span>${Utilities.formatCurrency(0)}</span></p>
          <p><span><span data-SF_translation_key="amountDue">Amount Due</span>: </span><span><span>${Utilities.formatCurrency(0)}</span></p>
        </span>
      `)
      $('.dashboard-comp-wrapper').html(`
        <p><span><span data-SF_translation_key="level">Level</span> 0 CV:</span> <span>${Utilities.formatCurrency(0)}</span></p>
        <span class="total-line"><p>Total :<span>${Utilities.formatCurrency(0)}</span></p></span>
      `)
      $('.chart-container').css('opacity', '1')
      $('.chart-container').css('height', '100%')
      return
    }

    let customerVolume_total = 0
    let personalVolume_total = 0
    let newVolume_total = 0
    const total_shares = share ? share.totalShares : 0
    var levels = {}
    var TRV = 0
    var earning_data = ''
    var periodEarningsPaid = 0.00
    var com_performance_total = 0
    var earning_total = 0

    $('.no-data').remove()
    $('.dashboard-chart-wrapper').show()
    $('#affiliate-performance-dashboard-chart').show()
    $('.retail-performance-title').show()
    $('.comp-performance-title').show()
    $('.earning-title').show()


    const newArray = [['Performance', 'Mhl']]
    commissions.forEach(commission => {
      const level = commission.level
      const type = commission.type
      periodEarningsPaid += commission.periodEarningsPaid
      if (!levels[level]) {
        levels[level] = {}
      }
      if (!levels[type]) {
        levels[level][type] = 0
      }
      if (!levels['periodRate']) {
        levels[level]['periodRate'] = 0
      }
      if (!levels['payout']) {
        levels[level]['payout'] = 0
      }
      levels[level][type] += commission.base
      levels[level]['periodRate'] += commission.periodRate
      levels[level]['payout'] = commission.payout
      if (type == 'CV') {
        customerVolume_total += commission.customerVolume
        personalVolume_total += commission.personalVolume
        newVolume_total += commission.newVolume
      }
    });
    TRV = customerVolume_total + personalVolume_total
    $('.dashboard-retail-wrapper').empty()
    $('.dashboard-retail-wrapper').append(`<p><span><span data-SF_translation_key="personalVolumePV">Personal Volume (PV)</span>:</span><span>${Utilities.formatCurrency(personalVolume_total)}</span></p>`)
    $('.dashboard-retail-wrapper').append(`<p><span><span data-SF_translation_key="customerVolumeCV">Customer Volume (CV)</span>:</span><span>${Utilities.formatCurrency(customerVolume_total)}</span></p>`)
    console.log(window.SFShopifyApp.move_volume_outside)

    if (!window.SFShopifyApp.move_volume_outside) {
      $('.dashboard-retail-wrapper').append(`<p><span><span data-SF_translation_key="newVolume">New Volume (NV):</span></span><span>${Utilities.formatCurrency(newVolume_total)}</span></p>`)
    }

    $('.dashboard-retail-wrapper').append(`<span class="total-line"><p><span><span data-SF_translation_key="totalPersonalSalesTPS">Total Personal Sales (TPS)</span>:</span><span>${Utilities.formatCurrency(TRV)}</span></p></span>`)
    if (window.SFShopifyApp.move_volume_outside) {
      $('.dashboard-retail-wrapper').append(`<p class="h2"><span><span data-SF_translation_key="newVolume">New Volume (NV):</span><span>${Utilities.formatCurrency(newVolume_total)}</span></p>`)
    }
    // debugger;

    $('.dashboard-comp-wrapper').empty()
    $('.dashboard-earnings-wrapper').empty()
    Object.keys(levels).forEach(function (level) {
      const data = levels[level]
      let type_bool = ''
      let percentage = data.payout
      if (data.CV) {
        type_bool = 'CV'
      }
      if (data.CV_PV) {
        type_bool = 'CV_PV'
      }

      var per = parseInt(data.periodRate * 100)
      earning_data = `<p><span><span data-SF_translation_key="level">Level</span> ${level} ${type_bool}:</span> ${per}%<span>${Utilities.formatCurrency(percentage.toFixed(2))}</span></p>`
      earning_total += Number(percentage.toFixed(2))

      $('.dashboard-earnings-wrapper').append(earning_data)
      Object.keys(levels[level]).forEach(function (key, index) {
        if (key == 'CV' || key == 'CV_PV') {
          var comp_performance = `<p><span><span data-SF_translation_key="level">Level</span> ${level} ${key}:</span><span>${Utilities.formatCurrency(levels[level][key])}</span></p>`
          com_performance_total += levels[level][key]
          $('.dashboard-comp-wrapper').append(comp_performance)
          if (level == 0) {
            newArray.push(['Total Personal Sales (TPS)', levels[level][key]])
          } else if (level == 1) {
            newArray.push(['Referred ' + window.SFShopifyApp.affiliate_term + ' Sales (<span data-SF_translation_key="level">Level</span> 1)', levels[level][key]])
          } else {
            newArray.push(['<span data-SF_translation_key="level">Level</span> ' + level, levels[level][key]])
          }
        }
      })
    })
    $('.dashboard-comp-wrapper').append(`<span class="total-line"><p>Total :<span>${Utilities.formatCurrency(com_performance_total)}</span></p></span>`)
    google.charts.load('current', { packages: ['corechart'] })
    google.charts.setOnLoadCallback(() => {
      const data = google.visualization.arrayToDataTable(newArray)
      const chart = new google.visualization.PieChart(document.getElementById('affiliate-performance-dashboard-chart'))
      chart.draw(data, {
        'title': (window.SFShopifyApp.periodPerformanceChartLabel ? window.SFShopifyApp.periodPerformanceChartLabel : 'Period Performance'),
        'chartArea.backgroundColor': '#ffffff00',
        'chartArea': {
          backgroundColor: '#ffffff00',
        },
      })
      let dashboardEarningsWrapperHtml = `
      <p class="mb-2"><span data-SF_translation_key="shareEarnings">Share Earnings</span>: <span class='share_earnings'>${Utilities.formatCurrency(total_shares)}</span></p>
      <span class="earnings-total-line"><p class="line"></p>
      <p><span><span data-SF_translation_key="totalEarnings">Total Earnings</span>: </span><span>${Utilities.formatCurrency(earning_total + total_shares)}</span></p>
      <p><span><span data-SF_translation_key="paidToDate">Paid to Date</span>: </span><span>${Utilities.formatCurrency(periodEarningsPaid)}</span></p>
      <p><span><span data-SF_translation_key="amountDue">Amount Due</span>: </span><span>${Utilities.formatCurrency(Math.abs((earning_total + total_shares) - periodEarningsPaid))}</span></p></span>`;
      $('.dashboard-earnings-wrapper').append(dashboardEarningsWrapperHtml)
      $('.chart-container').css('opacity', '1')
      $('.chart-container').css('height', '100%')
    })
  },
  getCommissions: (affiliateId, date) => {
    return $.ajax({
      type: 'GET',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/monthly`,
      data: {
        id: affiliateId,
        period: date,
      },
    })
  },
  setBonuses: (bonuses) => {
    if (!bonuses || !bonuses.length) {
      $('.dashboard-bonus-inner-wrapper').empty()
      $('.dashboard-bonus-title').hide()
      return
    }

    let total_recruits = 0
    let bonus_levels = []
    let qualified_total_recruits = 0
    let total_bonuses = ''

    for (var i = 0; i < bonuses.length; i++) {
      var bonus = bonuses[i]
      var level = bonus.level
      var type = bonus.type
      var rate = bonus.bonusRate
      // debugger;
      if (!bonus_levels[level]) {
        bonus_levels[level] = {}
        total_recruits = bonus.recruitsTotal
        qualified_total_recruits = bonus.recruitsQualified
      }
      if (!bonus_levels[type]) {
        bonus_levels[level][type] = 0
      }
      if (!bonus_levels[rate]) {
        bonus_levels[level]['rate'] = 0
      }
      bonus_levels[level][type] += bonus.bonusEarnings
      bonus_levels[level]['rate'] += bonus.bonusRate * 100
      total_bonuses += bonus.bonusEarnings
    }
    $('.dashboard-bonus-inner-wrapper').empty()

    $('.dashboard-bonus-wrapper').append(`<div class="dashboard-bonus-inner-wrapper">
      <p><span><span data-SF_translation_key="level">Level</span>:</span> <span>${level}</span></p>
      <p>Recruits: <span>${total_recruits}</span></p>
      <p>Qualified Recruits: <span>${qualified_total_recruits}</span></p>
      <p>${total_bonuses}</p>
    </div>`)
  },
  getBonuses: (affiliateId, date) => {
    return $.ajax({
      type: 'GET',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/monthly/bonus`,
      data: {
        id: affiliateId,
        period: date,
      },
    })
  },
  // order table functions
  updatePagination: ($table, currentPage, totalPages, rowsPerPage) => {
    $('#pagination span').text('Page ' + currentPage + ' of ' + totalPages)
    $table
      .find('tbody tr')
      .hide()
      .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
      .show()
  },
  setOrders: (data) => {
    $('#dataTableContainer').empty()
    $('#pagination').empty()
    // Create the table
    var $table = $('<table>').appendTo('#dataTableContainer')
    $('<thead>').appendTo($table)
    $('<tr>').appendTo($table.find('thead'))
    $.each(['<span data-SF_translation_key="orderID">Order ID</span>', '<span data-SF_translation_key="affiliateID">' + window.SFShopifyApp.affiliate_term + ' ID</span>', '<span data-SF_translation_key="email">Email</span>', '<span data-SF_translation_key="pv">PV</span>', '<span data-SF_translation_key="cv">CV</span>', '<span data-SF_translation_key="nv">NV</span>', '<span data-SF_translation_key="date">Date</span>'], function (i, v) {
      $('<th>').html(v).appendTo($table.find('thead tr'))
    })
    $('<tbody>').appendTo($table)

    // Add the data to the table
    $.each(data, function (i, v) {
      let date_string = v.orderDate
      let date_only = date_string.split('T')[0]
      $('<tr>')
        .appendTo($table.find('tbody'))
        .append($('<td>').text(v.orderNumber))
        .append($('<td>').text(v.affiliateId))
        .append($('<td>').text(v.customerEmail))
        .append($('<td>').text(Utilities.formatCurrency(v.personalVolume)))
        .append($('<td>').text(Utilities.formatCurrency(v.customerVolume)))
        .append($('<td>').text(Utilities.formatCurrency(v.newVolume)))
        .append($('<td>').text(date_only))
    })

    // Add the search functionality
    $('#searchBox').on('keyup', function () {
      var searchTerm = $(this).val().toLowerCase()
      $table
        .find('tbody tr')
        .hide()
        .filter(function () {
          return $(this).text().toLowerCase().indexOf(searchTerm) > -1
        })
        .show()
    })

    // Add the pagination functionality
    var rowsPerPage = 4
    var currentPage = 1
    var totalPages = (data && data.length ? Math.ceil(data.length / rowsPerPage) : 0)
    if (totalPages > 1) {
      $('#pagination').append($('<span>').text('Page ' + currentPage + ' of ' + totalPages))
      $('<button>')
        .text('')
        .prependTo('#pagination')
        .click(function () {
          if (currentPage > 1) {
            currentPage--
            AffiliateDashboard.updatePagination($table, currentPage, totalPages, rowsPerPage)
          }
        })
      $('<button>')
        .text('')
        .appendTo('#pagination')
        .click(function () {
          if (currentPage < totalPages) {
            currentPage++
            AffiliateDashboard.updatePagination($table, currentPage, totalPages, rowsPerPage)
          }
        })

      $table
        .find('tbody tr')
        .hide()
        .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
        .show()
    }
  },
  getOrders: (affiliateId, date) => {
    return $.ajax({
      type: 'GET',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/orders`,
      data: {
        id: affiliateId,
        period: date,
      },
      success: function (data) {
        const orders = data.orders
        $('.affiliate-order-snippet').show()
        AffiliateDashboard.setOrders(orders)
        if (!orders || orders.length == 0) {
          $('.affiliate-order-snippet').hide()
        }
      },
      error: function (xhr, status, error) {
        // handle error
        console.log('affiliate/orders' + error.responseText)
      },
    })
  },
  // DownLine order functions
  setDownLine: (data) => {
    $('#downline-dataTableContainer').empty()
    $('#downline-pagination').empty()

    // Create the table
    const $downlineTable = $('<table>').appendTo('#downline-dataTableContainer')
    $('<thead>').appendTo($downlineTable)
    $('<tr>').appendTo($downlineTable.find('thead'))
    $.each([
      '<span data-SF_translation_key="name">Name</span>',
      '<span data-SF_translation_key="affiliateID">' + window.SFShopifyApp.affiliate_term + ' ID</span>',
      '<span data-SF_translation_key="email">Email</span>',
      '<span data-SF_translation_key="pv">PV</span>',
      '<span data-SF_translation_key="cv">CV</span>',
      '<span data-SF_translation_key="tv">TV</span>',
      '<span data-SF_translation_key="nv">NV</span>'
    ], function (i, v) {
      $('<th>').html(v).appendTo($downlineTable.find('thead tr'))
    })
    $('<tbody>').appendTo($downlineTable)

    // Add the data to the table
    $.each(data, function (i, v) {
      if ((window.SFShopifyApp.affiliate_dashboard && window.SFShopifyApp.affiliate_dashboard.remove_oneself_from_referred_orders) && window.SFShopifyApp.customer_email == v.email) {
        return;
      }
      $('<tr>')
        .appendTo($downlineTable.find('tbody'))
        .append($('<td>').html('<span>' + v.name + ' ' + v.familyName + '</span>'))
        .append($('<td>').text(v.id))
        .append($('<td>').text(v.email))
        .append($('<td>').text(Utilities.formatCurrency(v.personalVolume)))
        .append($('<td>').text(Utilities.formatCurrency(v.customerVolume)))
        .append($('<td>').text(Utilities.formatCurrency(v.personalVolume + v.customerVolume)))
        .append($('<td>').text(Utilities.formatCurrency(v.newVolume)))
    })

    // Add the search functionality
    $('#downline-searchBox').on('keyup', function () {
      var searchTerm = $(this).val().toLowerCase()
      $downlineTable
        .find('tbody tr')
        .hide()
        .filter(function () {
          return $(this).text().toLowerCase().indexOf(searchTerm) > -1
        })
        .show()
    })

    // Add the downline-pagination functionality
    var rowsPerPage = 10
    var currentPage = 1
    var totalPages = (data && data.length ? Math.ceil(data.length / rowsPerPage) : 0)
    if (totalPages > 1) {
      $('#downline-pagination').append($('<span>').text('Page ' + currentPage + ' of ' + totalPages))
      $('<button>')
        .text(' ')
        .prependTo('#downline-pagination')
        .click(function () {
          if (currentPage > 1) {
            currentPage--
            AffiliateDashboard.updateDownline_pagination($downlineTable, currentPage, totalPages, rowsPerPage)
          }
        })
      $('<button>')
        .text(' ')
        .appendTo('#downline-pagination')
        .click(function () {
          if (currentPage < totalPages) {
            currentPage++
            AffiliateDashboard.updateDownline_pagination($downlineTable, currentPage, totalPages, rowsPerPage)
          }
        })

      $downlineTable
        .find('tbody tr')
        .hide()
        .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
        .show()
    }
  },
  updateDownline_pagination: ($table, currentPage, totalPages, rowsPerPage) => {
    $('#downline-pagination span').text('Page ' + currentPage + ' of ' + totalPages)
    $table
      .find('tbody tr')
      .hide()
      .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
      .show()
  },
  getDownline: (affiliateId, date) => {
    return $.ajax({
      type: 'GET',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/downline`,
      data: {
        id: affiliateId,
        period: date,
      },
      success: function (data) {
        const downline = data.downline
        $('.affiliate-downline-snippet').show()
        AffiliateDashboard.setDownLine(downline)
        if (!downline || !downline.length) {
          $('.affiliate-downline-snippet').hide()
        }
      },
      error: function (xhr, status, error) {
        // handle error
        console.log('error' + error.responseText)
      },
    })
  },
  onClickCopyBtn: function ($btn) {
    $btn.on('click', function () {
      const $this = $(this)
      const id = $this.attr('data-copy_element_id')
      Utilities.copyElementValueToClipboard(id)
      $this.text('✓ Copied')
      setTimeout(function () {
        $this.text('Copy')
      }, 1000)
    })
  },
}

const ShoppingWith = {
  onLoad: () => {
    const $SF_shopping_with_container = $('.SF-shopping_with_container');
    if (!$SF_shopping_with_container.length) {
      return
    }
    ShoppingWith.loadAffiliate()
  },
  loadAffiliate: () => {
    const $SF_shopping_with_container = $('.SF-shopping_with_container').first();
    const SF_attribution = $SF_shopping_with_container.data('SF_attribution');
    const xmark_icon_url = $SF_shopping_with_container.data('xmark_icon_url');
    const edit_icon_url = $SF_shopping_with_container.data('edit_icon_url');

    if (!SF_attribution) {
      if (window.SFShopifyApp.affiliate_dashboard.enable_option_to_add_edit_upline) {
        let html = `You are not shopping with anyone <a href="javascript:void(0)" id="btn-update-shopping-underneath" class="v-btn v-btn-transparent text-danger"> <img height="16" width="15" src="${edit_icon_url}"/> </a>`;
        html += '<br>' + ShoppingWith.referringSearchForm()
        $SF_shopping_with_container.html(html)
        ShoppingWith.onSearchAffiliates()
        ShoppingWith.onUpdateShoppingWith()
      }
      return;
    }

    ShoppingWith.getAffiliate(SF_attribution).then(res => {
      let html = `You are shopping with: <b>${res.affiliate.name} ${res.affiliate.familyName}</b>`

      if (window.SFShopifyApp.affiliate_dashboard.enable_option_to_remove_upline) {
        html += ` <a href="javascript:void(0)" id="btn-update-shopping-underneath" class="v-btn v-btn-transparent text-danger"> <img height="16" width="15" src="${edit_icon_url}"/> </a>`;
      }
      if (window.SFShopifyApp.affiliate_dashboard.enable_option_to_add_edit_upline) {
        html += ` <a href="javascript:void(0)" id="btn-remove-shopping-underneath" class="v-btn v-btn-transparent text-danger"> <img height="18" width="15" src="${xmark_icon_url}"/> </a>`;
        html += '<br>' + ShoppingWith.referringSearchForm()
      }
      $SF_shopping_with_container.html(html)
      ShoppingWith.removeShoppingWith()
      ShoppingWith.onSearchAffiliates()
      ShoppingWith.onUpdateShoppingWith()
    }).catch(err => {
      console.log(err)
    })

  },
  getAffiliate: (affiliateId) => {
    return $.ajax({
      type: 'GET',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate`,
      data: {
        id: affiliateId,
      },
    })
  },
  removeShoppingWith: () => {
    const $btn_remove_shopping_underneath = $('#btn-remove-shopping-underneath');
    if (!$btn_remove_shopping_underneath.length) {
      return;
    }
    $btn_remove_shopping_underneath.on('click', () => {
      $.ajax({
        type: 'DELETE',
        url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/upline`,
        success: (response) => {
          console.log(response)
          if (response.success == true) {
            location.reload()
          } else {
            alert('Unable to remove shopping with.')
          }
        },
        error: (error) => {
          console.log(error)
        }
      })
    })
  },
  onUpdateShoppingWith: () => {
    const $btn_update_shopping_underneath = $('#btn-update-shopping-underneath');
    if (!$btn_update_shopping_underneath.length) {
      return;
    }
    const $referring_affiliate_container = $('#referring-affiliate-container')
    $btn_update_shopping_underneath.on('click', () => {
      if ($referring_affiliate_container.hasClass('opened')) {
        $referring_affiliate_container.slideUp();
        $referring_affiliate_container.removeClass('opened')
      } else {
        $referring_affiliate_container.addClass('opened')
        $referring_affiliate_container.slideDown();
      }
    })
  },
  referringSearchForm: () => {
    const $SF_shopping_with_container = $('.SF-shopping_with_container').first();
    const xmark_icon_url = $SF_shopping_with_container.data('xmark_icon_url');
    return `
    <div class="mb-3" style="width:300px;display:none" id="referring-affiliate-container">
      <label for="referrer" class="form-label" data-SF_label_key="referringInformation">Referring ${window.SFShopifyApp.affiliate_term}</label>
      <label style="display:none" for="affiliate-search" data-SF_label_key="searchAffiliate"></label>
      <div class="affiliate-dropdown-container" id="affiliate-dropdown-container">
        <input type="hidden" name="referrer" id="referring-affiliate-id">
        <input type="text" id="affiliate-search" class="SF-form-control" placeholder="Search ${window.SFShopifyApp.affiliate_term}">
        <p id="affiliate-search-status"></p>
        <ul id="affiliate-dropdown"></ul>
      </div>
      <div id="selected-referring-affiliate" class="selected-referring-affiliate">
        <div class="selected-referring-affiliate_info">
          <div><strong id="selected-referring-affiliate_name" class="selected-referring-affiliate_name"></strong> -
            <span id="selected-referring-affiliate_id"></span></div>
          <p class="selected-referring-affiliate_address" id="selected-referring-affiliate_address"></p>
        </div>
        <div class="selected-referring-affiliate_unselect" id="selected-referring-affiliate_unselect">
          <img height="20" width="15" src="${xmark_icon_url}"/>
        </div>
      </div>
      <button id="save-referring-affiliate" style="width:100%;display:none;" class="SF-btn">Update Referring Affiliate</button>
    </div>`
  },
  onSearchAffiliates: () => {
    let keyupTimer;
    const searchInput = document.getElementById('affiliate-search')
    searchInput.addEventListener('keyup', function () {
      clearTimeout(keyupTimer);
      keyupTimer = setTimeout(function () {
        const searchValue = searchInput.value.trim().toLowerCase()
        ShoppingWith.searchAffiliates(searchValue)
      }, 800);
    })
  },
  searchAffiliates: (search) => {
    const $affiliateSearchStatus = document.getElementById('affiliate-search-status')
    $affiliateSearchStatus.innerHTML = 'Searching....'
    $.ajax({
      type: 'GET',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliates`,
      data: {
        search
      },
      success: function (data) {
        const dropdown = document.getElementById('affiliate-dropdown')
        dropdown.innerHTML = ''

        const affiliates = data.affiliates
        if (!affiliates || !affiliates.length) {
          $affiliateSearchStatus.innerHTML = 'Unable to find any affiliates.'
          return
        }
        $affiliateSearchStatus.innerHTML = 'Found ' + affiliates.length + ' affiliates.'

        for (let i = 0; i < affiliates.length; i++) {
          const affiliate = affiliates[i]
          const option = `<li class="affiliate-dropdown-item" data-id="${affiliate.id}" data-name="${affiliate.name}" data-city="${affiliate.address.city}" data-state="${affiliate.address.state}">
          <div><strong class="affiliate-dropdown-item_name">${affiliate.name}</strong> - ${affiliate.id}</div>
          <p class="affiliate-dropdown-item_address">${affiliate.address.city}, ${affiliate.address.state}</p>
          </li>`
          dropdown.innerHTML = dropdown.innerHTML + option
        }
        ShoppingWith.onAffiliateDropdownItemClick()
      },
      error: function (xhr, status, error) {
        console.log('Error:', error)
        console.log('xhr:', xhr)
        console.log('status:', status)
      },
    })
  },
  onAffiliateDropdownItemClick: () => {
    const $affiliateDropdownItems = document.querySelectorAll('.affiliate-dropdown-item')
    for (const $affiliateDropdownItem of $affiliateDropdownItems) {
      $affiliateDropdownItem.addEventListener('click', function () {
        const $save_referring_affiliate = $('#save-referring-affiliate')
        const affiliate_id = this.getAttribute('data-id')
        const affiliate_name = this.getAttribute('data-name')
        const affiliate_city = this.getAttribute('data-city')
        const affiliate_state = this.getAttribute('data-state')

        document.getElementById('affiliate-dropdown-container').style.display = 'none'
        document.getElementById('selected-referring-affiliate').style.display = 'flex'
        document.getElementById('referring-affiliate-id').value = affiliate_id
        document.getElementById('selected-referring-affiliate_id').innerHTML = affiliate_id
        document.getElementById('selected-referring-affiliate_name').innerHTML = affiliate_name
        document.getElementById('selected-referring-affiliate_address').innerHTML = (affiliate_city + ', ' + affiliate_state)

        $save_referring_affiliate.show()
        $save_referring_affiliate.on('click', ShoppingWith.onSaveReferringAffiliateClick)
        document.getElementById('selected-referring-affiliate_unselect').addEventListener('click', function () {
          document.getElementById('affiliate-dropdown-container').style.display = 'block'
          document.getElementById('selected-referring-affiliate').style.display = 'none'
          document.getElementById('referring-affiliate-id').value = ''
          document.getElementById('affiliate-dropdown').innerHTML = ''
          document.getElementById('affiliate-search').value = ''
          document.getElementById('affiliate-search-status').innerHTML = ''
          $save_referring_affiliate.hide()
          $save_referring_affiliate.off('click', ShoppingWith.onSaveReferringAffiliateClick)
        })
      })
    }
  },
  onSaveReferringAffiliateClick: (e) => {
    const $saveBtn = $(e.currentTarget)
    if ($saveBtn.attr('disabled')) {
      return;
    }
    $saveBtn.html('Saving..')
    $saveBtn.attr('disabled', true)
    $.ajax({
      type: 'PUT',
      url: `${window.SFShopifyApp.proxy_url}/SFfiliate/affiliate/upline`,
      data: {
        referring_affiliate_id: document.getElementById('referring-affiliate-id').value
      },
      success: (response) => {
        console.log(response)
        if (response.success == true) {
          alert('Successfully updated shopping with.')
          location.reload()
        } else {
          $saveBtn.removeAttr('disabled')
          alert('Unable to update shopping with.')
        }
      },
      error: (error) => {
        $saveBtn.html('Update Referring Affiliate')
        console.log(error)
      }
    })
  }
}
window.addEventListener('load', () => {
  AffiliateDashboard.onLoad()
  ShoppingWith.onLoad()
});
